import React from "react";
import { ProductDetailPageMetadata } from "./PDP_Metadata/ProductDetailPageMetadata";
import { BDPProductJsonLd, PDPProductJsonLd } from "./structured-data/ProductJsonLd";
import { BreadcrumbsJsonLd } from "./structured-data/BreadcrumbsJsonLd";
import { getProductAvailability } from "./state/get-product-availability";
import { PageProps } from "./product-detail-page-layout";
import type {
  PDPSwarovskiProductFrontend,
  PDPSwarovskiProductVariantFrontend,
} from "./PDP_SingleImageCarousel/state/types";
import type { EnrichedSwarovskiBundleProductFrontend, ProductDetailPageDataShared } from "@swo/storefront";

export const PDPMetadata: React.FC<{
  selectedProduct: PDPSwarovskiProductFrontend;
  selectedVariant: PDPSwarovskiProductVariantFrontend | undefined;
  page: PageProps["page"];
  seoMetadata: ProductDetailPageDataShared["seoMetadata"];
  taxonomy: ProductDetailPageDataShared["taxonomy"];
  availability: ProductDetailPageDataShared["availability"];
}> = ({ selectedProduct, selectedVariant, page, seoMetadata, taxonomy, availability }) => {
  const availabilityF = getProductAvailability(availability);

  return (
    <>
      <ProductDetailPageMetadata
        selectedProduct={selectedProduct}
        selectedVariant={selectedVariant}
        path={page.path}
        seoMetadata={seoMetadata}
      />

      {availabilityF !== null ? (
        <PDPProductJsonLd product={selectedProduct} productAvailabilityPerVariant={availabilityF} />
      ) : null}
      <BreadcrumbsJsonLd breadcrumbs={taxonomy.breadcrumbs} />
    </>
  );
};

export const BDPMetadata: React.FC<{
  selectedProduct: EnrichedSwarovskiBundleProductFrontend;
  page: PageProps["page"];
  seoMetadata: ProductDetailPageDataShared["seoMetadata"];
  taxonomy: ProductDetailPageDataShared["taxonomy"];
}> = ({ selectedProduct, page, seoMetadata, taxonomy }) => {
  return (
    <>
      <ProductDetailPageMetadata
        selectedProduct={selectedProduct}
        selectedVariant={undefined}
        path={page.path}
        seoMetadata={seoMetadata}
      />

      <BDPProductJsonLd product={selectedProduct} />

      <BreadcrumbsJsonLd breadcrumbs={taxonomy.breadcrumbs} />
    </>
  );
};
